// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pictrue[data-v-e703c786] {\n  width: 60px;\n  height: 60px;\n  border: 1px dotted rgba(0, 0, 0, 0.1);\n  margin-right: 10px;\n  position: relative;\n  cursor: pointer;\n}\n.pictrue img[data-v-e703c786] {\n  width: 100%;\n  height: 100%;\n}\n.btndel[data-v-e703c786] {\n  position: absolute;\n  z-index: 1;\n  width: 20px !important;\n  height: 20px !important;\n  left: 46px;\n  top: -4px;\n}", ""]);
// Exports
module.exports = exports;
